import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, makeStyles, mergeClasses } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useCommonStyles } from '../../../common/hooks';
import { FormInput } from '../../shared-components/form';

interface CreateProgramModalProps {
  isModalOpen: boolean;
  onSubmitModal(name: string): void;
  onDismissModal(): void;
}

const useStyles = makeStyles({
  surface: { maxWidth: '416px', },
});

const CreateProgramModalImpl: React.FC<CreateProgramModalProps> = (props) => {
  const {
    isModalOpen,
    onSubmitModal,
    onDismissModal,
  } = props;

  const commonStyles = useCommonStyles();
  const styles = useStyles();

  const [name, setName] = useState<string>('');

  const handleDismissModal = (): void => {
    setName('');
    onDismissModal();
  };

  const handleSubmitModal = (): void => {
    const programName = name;
    handleDismissModal();
    onSubmitModal(programName);
  };

  return (
    <Dialog
      open={isModalOpen}
      onOpenChange={(_, data) => {
        if (!data.open) handleDismissModal();
      }}
    >
      <DialogSurface className={mergeClasses(commonStyles.modalSurface, styles.surface)}>
        <DialogBody className={commonStyles.modalBody}>
          <DialogTitle>
            Create a new program
          </DialogTitle>

          <DialogContent>
            <FormInput
              required
              label='Name'
              onChange={(value) => setName(value)}
              inputProps={{ value: name, }}
            />
          </DialogContent>

          <DialogActions>
            <Button
              appearance='secondary'
              onClick={handleDismissModal}
            >
              Back
            </Button>
            <Button
              appearance='primary'
              disabled={name === ''}
              onClick={handleSubmitModal}
            >
              Confirm
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export const CreateProgramModal = observer(CreateProgramModalImpl);
